import $ from 'jquery';
import PubSub from 'pubsub-js';
import App from '../app.js';
import ScrollMagic from 'scrollmagic';
var NeonRentals = function(){

	var $section,
			$cloud,
			$lightning,
			$lightningIMG,
			$flyout,
			isActive = false,
			activeClass = 'is-active',
			controller = App.getScrollMagicController();

	// Set up vars
	$section = $('#NeonRentals');
	if( $section.length < 1 ) return false; // Kill if no section

	console.log('NeonRentals.init()');

	$flyout = $section.find('.js-flyout');
	$cloud = $section.find('.js-cloud');
	$lightning = $section.find('.js-lightning');
	$lightningIMG = $lightning.find('img');

//
	new ScrollMagic.Scene({triggerElement: $section[0], duration: '150%' })
					.setClassToggle( $section[0], activeClass) // add class toggle
					// .addIndicators() // add indicators (requires plugin)
					.addTo(controller)
					.reverse(true)
					.on('start', function(event){
						positionLightning();
					});


	// Subscribe to PubSub Events
	PubSub.subscribe('updatelayout', updateLayout);
	updateLayout();


	// function openSection(){
	// 	positionLightning();
	// 	$section.addClass(activeClass);
	// 	isActive = true;
	// }

	// function closeSection() {
	// 	$section.removeClass(activeClass);
	// 	$lightning.attr('style', '');
	// 	isActive = false;
	// }

	function updateLayout() {
		// var difference = $lightning.offset().top - $cloud.offset().top,
		// 		yPercent = 0.2718650899;
		if( $section.hasClass(activeClass) ) {
			positionLightning();
		}

	}

	function positionLightning() {
		var difference = $flyout.outerHeight() - parseInt($lightning.css('padding-top'), 10);
		$lightning.css({
			'transform': 'translateY(' + difference + 'px)'
		});
	}

};

export default NeonRentals();